import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as jwt_decode from 'jwt-decode';
import { withRouter } from 'react-router-dom';
import {
  Layout,
  Row,
  Col,
  Table,
  Card,
  Switch,
  DatePicker,
  Button,
  List,
  Collapse,
  Badge,
  message,
} from 'antd';
import moment from 'moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getUserData, setChecketedRow } from '../../redux/actions';

import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Breadcrumb from '../../components/Breadcrumb';

import Service from './Service';
import './styles.css';

const { Content } = Layout;
const { Panel } = Collapse;

const NPS = 'nps';
const ELOGIOS = 'elogio';
const CRITICA = 'critica';
const DETRATOR = 'detrator';
const PROMOTOR = 'promotor';
const NEUTRO = 'neutro';
const ID_PERGUNTA_NPS = 85;
const ID_PERGUNTA_ELOGIO = 86;
const ID_PERGUNTA_CRITICA = 87;
const DETRATOR_DESC = 'Detrator';
const PROMOTOR_DESC = 'Promotor';
const NEUTRO_DESC = 'Neutro';
// DATE_FORMAT e o formato que o back-end espera na URL e que guardamos no
// state - nao mudar (as rotas sao /{dataInicial}/{dataFinal}/ e o DateTime do
// C# interpreta aaaa-mm-dd). FORMATO_EXIBICAO e so o que o usuario ve.
// Cuidado no onChange: o antd entrega a data ja formatada conforme
// FORMATO_EXIBICAO, entao a string dele NAO serve pra chamar a API.
const DATE_FORMAT = 'YYYY-MM-DD';
const FORMATO_EXIBICAO = 'DD/MM/YYYY';
const DATE_INITAL = moment(
  new Date(new Date().setDate(new Date().getDate() - 30))
).format('YYYY-MM-DD');
const DATE_FINAL = moment(
  new Date(new Date().setDate(new Date().getDate()))
).format('YYYY-MM-DD');

class Comments extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: [],
      selectedRowKeys: [],
      selectedRows: [],
      loading: false,
      [NPS]: false,
      [ELOGIOS]: false,
      [CRITICA]: false,
      [DETRATOR]: false,
      [PROMOTOR]: false,
      [NEUTRO]: false,
      npsTeste: [],
      record: {
        type: '-',
      },
      dataInitial: DATE_INITAL,
      dataFinal: DATE_FINAL,
      rowColor: '',
      tipoExibicaoQuesito: 1,
      idGrupo: 0,
      idUnidade: 0,
    };
    this.service = new Service();
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    if (!this.service.isLogged()) {
      this.props.history.push('/login');
    } else {
      const tokenLogin = localStorage.getItem('token');
      const decodeToken = jwt_decode(tokenLogin);
      const idUnidade = this.unidadeSelecionada();
      const idGrupo =
        this.props.companySelected.length > 0
          ? this.props.companySelected[0].id
          : 0;
      this.setState({
        role: decodeToken.role,
        dataUser: decodeToken,
        loading: true,
        idUnidade,
        idGrupo,
      });
      this.handleDate(idGrupo, idUnidade);
      this.loadTipoExibicaoQuesito();
    }
  }

  // Unidade selecionada no Header. filialId e a UNICA fonte que representa
  // "Ver todas as unidades" (sentinela 999999): nesse caso dataFilial fica
  // vazia, entao ler dataFilial[0].id fazia a tela buscar os dados de UMA
  // filial - a selecionada antes, que continua no Redux durante a troca,
  // porque o Header despacha 4 acoes separadas. Aqui o sintoma era mais
  // discreto que nas outras telas: a coluna "Unidade" aparecia (ela ja
  // dependia de filialId), dando a impressao de que a lista era consolidada,
  // mas os comentarios eram de uma unidade so.
  unidadeSelecionada = (props = this.props) =>
    props.filialId > 0
      ? props.filialId
      : props.dataFilial.length > 0
      ? props.dataFilial[0].id
      : 0;

  componentWillReceiveProps(props) {
    const idUnidade = this.unidadeSelecionada(props);
    const idGrupo =
      props.companySelected.length > 0 ? props.companySelected[0].id : 0;
    this.setState({
      idUnidade,
      idGrupo,
    });
    if (
      (idUnidade > 0 && idUnidade !== this.state.idUnidade) ||
      (idGrupo > 0 && idGrupo !== this.state.idGrupo)
    ) {
      this.handleDate(idGrupo, idUnidade);
    }
  }

  // Sem isso, uma busca ainda em andamento quando o usuario navega pra
  // outra tela (o componente desmonta, mas a promise continua rodando)
  // acabava chamando setState num estado que nunca foi atualizado de
  // verdade.
  componentWillUnmount() {
    this._isMounted = false;
  }

  handleDate = async (idGrupo, idUnidade, periodo) => {
    // Mesma protecao aplicada em Nps/index.js e IndexBlue/index.js:
    // componentWillReceiveProps pode chamar handleDate varias vezes seguidas
    // ao trocar de filial, e sem isso a resposta mais antiga pode chegar
    // depois e sobrescrever o resultado certo com dado desatualizado.
    const requestId = (this.requestSeq = (this.requestSeq || 0) + 1);
    this.setState({ loading: true });

    // Preserva o periodo escolhido no filtro. Antes buscava sempre
    // DATE_INITAL/DATE_FINAL (30 dias fixos), entao trocar de unidade
    // devolvia os dados pro periodo padrao. O parametro `periodo` existe
    // pro clearFilter, que precisa forcar o padrao sem depender do
    // setState anterior ja ter sido aplicado.
    const inicio = (periodo && periodo.inicio) || this.state.dataInitial || DATE_INITAL;
    const fim = (periodo && periodo.fim) || this.state.dataFinal || DATE_FINAL;

    const idUnidadePadrao = this.unidadeSelecionada();
    const idGrupoPadrao =
      this.props.companySelected.length > 0
        ? this.props.companySelected[0].id
        : 0;
    let result = await this.service.getDataFeedbacks(
      inicio,
      fim,
      idUnidade > 0 ? idUnidade : idUnidadePadrao,
      idGrupo > 0 ? idGrupo : idGrupoPadrao
    );

    if (!this._isMounted || requestId !== this.requestSeq) return;

    if (result) {
      const data = result.object;

      const racionais =
        data &&
        data.filter(item => {
          return item.respostas.idSegmentoPergunta === 1;
        });
      // const emocionais = data && data.filter(_emocionais => {
      //   return _emocionais.respostas.idSegmentoPergunta === 2
      // })

      let selectedRowKeys = result.object.filter(item => item.verificado);
      selectedRowKeys = selectedRowKeys.map(item => item.id);

      this.setState({
        selectedRowKeys,
        data: result.object,
        // Reflete o periodo REALMENTE usado na busca, nao o padrao fixo -
        // e isso que o campo do filtro exibe.
        dataInitial: inicio,
        dataFinal: fim,
        racionais,
        loading: false,
      });
      this.formatDate(result.object);
    } else {
      this.props.history.push('/login');
    }
  };

  onChangeFeedbacks = async (value, dateString) => {
    // Le dos objetos moment (1o argumento), NAO de dateString: essa vem no
    // formato de exibicao (dd/mm/aaaa) e a API espera aaaa-mm-dd.
    this.setState({
      dataInitial: value && value[0] ? value[0].format(DATE_FORMAT) : DATE_INITAL,
      dataFinal: value && value[1] ? value[1].format(DATE_FORMAT) : DATE_FINAL,
    });
  };

  onOk = value => {
    console.log('onOk: ', value);
  };

  onChange(checked, filterName) {
    this.setState({ [filterName]: checked });
  }

  applyFilter = async () => {
    const requestId = (this.requestSeq = (this.requestSeq || 0) + 1);
    this.setState({ loading: true });
    const { dataInitial, dataFinal } = this.state;

    // Lista base sobre a qual os filtros de tipo serao aplicados. Comeca com
    // o que ja esta em memoria e e substituida se a busca por periodo rodar -
    // antes o codigo relia this.state.data logo depois do setState, que ainda
    // podia nao ter sido aplicado.
    let lista = this.state.data;

    if (dataInitial && dataFinal) {
      const idUnidade = this.unidadeSelecionada();
      const idGrupo =
        this.props.companySelected.length > 0
          ? this.props.companySelected[0].id
          : 0;
      let result = await this.service.getDataFeedbacks(
        dataInitial,
        dataFinal,
        idUnidade,
        idGrupo
      );

      if (!this._isMounted || requestId !== this.requestSeq) return;

      result.object.forEach(item => {
        item.dataRespostas = moment(item.dataRespostas).format(
          'DD/MM/YYYY HH:mm'
        );
      });

      if (result !== undefined) {
        lista = result.object;
        this.setState({ data: result.object });
      }
    }

    const data = this.filtrarPorTipo(lista);

    let selectedRowKeys = data.filter(item => item.verificado);
    selectedRowKeys = selectedRowKeys.map(item => item.id);

    this.setState({ dataTable: data, loading: false, selectedRowKeys });
  };

  // Aplica os filtros de comentario/tipo (os toggles da tela) sobre a lista.
  // Extraido pra ser usado por DOIS caminhos: o botao "Aplicar" e qualquer
  // recarga de dados (troca de unidade, por exemplo). Antes so o botao
  // aplicava - trocar de unidade recarregava a lista COMPLETA enquanto os
  // toggles continuavam marcados na tela, mostrando dado que nao correspondia
  // ao filtro exibido.
  filtrarPorTipo = lista => {
    let data = lista || [];

    if (this.state[NPS]) {
      data = data.filter(item => {
        const has_repostas = item.respostas.find(res => {
          return res.idPergunta === ID_PERGUNTA_NPS && res.valorChar !== null;
        });
        return has_repostas !== undefined;
      });
    }

    if (this.state[ELOGIOS]) {
      data = data.filter(item => {
        const has_repostas = item.respostas.find(res => {
          return (
            res.idPergunta === ID_PERGUNTA_ELOGIO && res.valorChar !== null
          );
        });
        return has_repostas !== undefined;
      });
    }

    if (this.state[CRITICA]) {
      data = data.filter(item => {
        const has_repostas = item.respostas.find(res => {
          return (
            res.idPergunta === ID_PERGUNTA_CRITICA && res.valorChar !== null
          );
        });
        return has_repostas !== undefined;
      });
    }

    if (this.state[DETRATOR]) {
      data = data.filter(item => {
        return item.nps >= 0 && item.nps <= 6;
      });
    }

    if (this.state[NEUTRO]) {
      data = data.filter(item => {
        return item.nps >= 7 && item.nps <= 8;
      });
    }

    if (this.state[PROMOTOR]) {
      data = data.filter(item => {
        return item.nps >= 9 && item.nps <= 10;
      });
    }

    return data;
  };

  clearFilter = () => {
    this.setState({
      nps: false,
      elogio: false,
      critica: false,
      detrator: false,
      promotor: false,
      neutro: false,
      loading: true,
      dataInitial: DATE_INITAL,
      dataFinal: DATE_FINAL,
    });

    // Passa o periodo explicitamente: o setState acima ainda pode nao ter
    // sido aplicado quando handleDate ler this.state.
    this.handleDate(undefined, undefined, {
      inicio: DATE_INITAL,
      fim: DATE_FINAL,
    });
    this.setState({ loading: false });
  };

  getType = record => {
    const { nps } = record;

    if (nps === null || (nps >= 0 && nps <= 6)) {
      return DETRATOR_DESC;
    }

    if (nps >= 7 && nps <= 8) {
      return NEUTRO_DESC;
    }

    return PROMOTOR_DESC;
  };

  getTypeColor = type => {
    if (type === DETRATOR_DESC) {
      return '#f5222d';
    }
    if (type === NEUTRO_DESC) {
      return '#faad14';
    }
    if (type === PROMOTOR_DESC) {
      return '#52c41a';
    }
    return '#eee';
  };

  // Recebe a lista por parametro (em vez de reler this.state.data) porque quem
  // chama acabou de fazer o setState, que pode ainda nao ter sido aplicado.
  formatDate = listaBruta => {
    let lista = listaBruta || this.state.data || [];
    lista.forEach(item => {
      item.dataRespostas = moment(item.dataRespostas).format(
        'DD/MM/YYYY HH:mm'
      );
    });
    // Reaplica os filtros de comentario/tipo que estao marcados na tela - sem
    // isso, recarregar (ex.: trocar de unidade) devolvia a lista completa com
    // os toggles ainda ligados.
    const dataTable = this.filtrarPorTipo(lista);
    this.setState({
      dataTable,
      // As linhas pre-marcadas ("verificado") tem que sair da lista que esta
      // realmente na tabela; senao ficam apontando pra linhas filtradas fora.
      selectedRowKeys: dataTable.filter(i => i.verificado).map(i => i.id),
    });
  };

  selectRow = record => {
    if (record) {
      this.setState({ rowColor: '#f5222d' });
    }

    const racionais = record.respostas.filter(item => {
      return item.idSegmentoPergunta === 1;
    });

    const racionaisTitles = racionais.map(item => {
      return { title: item.descricaoPergunta, description: item.valorInteiro };
    });

    const emocionais = record.respostas.filter(item => {
      return item.idSegmentoPergunta === 2;
    });

    const emocionaisTitles = emocionais.map(item => {
      return { title: item.descricaoPergunta, description: item.valorInteiro };
    });

    const outros = record.respostas.filter(item => {
      return item.idSegmentoPergunta === 5;
    });

    const outrosTitles = outros.map(item => {
      return {
        title: item.descricaoPergunta,
        description: item.descricaoSubPergunta,
      };
    });

    const nps = record.respostas.filter(item => {
      return item.idSegmentoPergunta === 3;
    });

    const elogios = record.respostas.filter(item => {
      return item.idPergunta === 86 && item.valorChar !== null;
    });

    const criticas = record.respostas.filter(item => {
      return item.idPergunta === 87 && item.valorChar !== null;
    });

    record['type'] = this.getType(record);
    this.setState({
      racionaisTitles,
      emocionaisTitles,
      outrosTitles,
      npsTeste: nps,
      elogios,
      criticas,
      record,
    });
  };

  checkAnswers = async selectRow => {
    message.loading('Processando', 1, () => {
      message.success(`Operação realizada com sucesso`, 1);
    });
    let selected = selectRow.map(i => i.id);
    let add = selected.filter(v => !this.state.selectedRowKeys.includes(v));
    let del = this.state.selectedRowKeys.filter(v => !selected.includes(v));
    add.forEach(async a => {
      await this.service.checkAnswers(a);
    });
    del.forEach(async d => {
      await this.service.checkAnswers(d);
    });

    this.props.setChecketedRow(selectRow);

    this.setState({
      selectedRowKeys: selected,
    });
  };

  exists(value, vitem) {
    for (let item of value) {
      if (item.id === vitem) {
        return true;
      }
    }
    return false;
  }

  onClickRow = record => {
    return {
      onClick: (event, index) => {
        this.selectRow(record, record, index, event);
        this.setState({
          rowId: record.id,
        });
      },
    };
  };
  setRowClassName = record => {
    return record.id === this.state.rowId ? 'clickRowStyl' : 'rowComment';
  };

  makeWhatsappUrl = phone => {
    let fullPhoneNumber = `55${phone.replace(/[^0-9]+/g, '')}`;

    return `https://wa.me/${fullPhoneNumber}`;
  };

  loadTipoExibicaoQuesito = async () => {
    let idEmpresa = 0;
    if (this.props.companySelected && this.props.companySelected.length > 0) {
      idEmpresa = this.props.companySelected[0].id;
    }
    const result = await this.service.consultarTipoExibicao(idEmpresa);
    this.setState({
      tipoExibicaoQuesito: result.object,
    });
  };

  render() {
    const { dataInitial, dataFinal } = this.state;

    const homeClient = {
      home: 'Início',
      user: 'Índice Blue',
      company: 'NPS',
      companyClient: 'Empresa',
      contracts: 'Evoluções',
      plans: 'Avaliações',
      indicadores: 'Visão Geral',
      configuration: 'Opções',
      logout: 'Sair',
      iconClient: {
        home: 'home',
        user: 'area-chart',
        company: 'pie-chart',
        companyClient: 'bank',
        contracts: 'line-chart',
        plans: 'message',
        indicadores: 'dashboard',
        configuration: 'setting',
        logout: 'logout',
      },
    };

    const routesClient = {
      home: 'client',
      user: 'indexBlue',
      company: 'nps',
      companyClient: 'companyClient',
      contracts: 'evolution',
      plans: 'comments',
      indicadores: 'indicadores',
      configuration: 'settings',
    };

    const columns = [
      {
        title: 'Data',
        dataIndex: 'dataRespostas',
        sorter: (a, b) => new Date(a.dataRespostas) - new Date(b.dataRespostas),
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        render: text => (text === '' ? 'Anônimo' : <a href="#">{text}</a>),
      },
      {
        title: 'Tel',
        dataIndex: 'celular',
        key: '3',
        render: text =>
          text !== '' ? (
            <a
              href={this.makeWhatsappUrl(text)}
              class="linkwhatsapp"
              target="_blank"
            >
              {text}
            </a>
          ) : (
            'Anônimo'
          ),
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: '4',
        render: text => (text === '' ? 'Anônimo' : text),
      },
      {
        title: this.props.filialId == 999999 ? 'Unidade' : '',
        dataIndex: this.props.filialId == 999999 ? 'nomeFilial' : '',
        key: '5',
        render: text => (this.props.filialId == 999999 ? text : ''),
      },
    ];

    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onChange: async (selectedRowKeys, selectedRows) => {
        this.checkAnswers(selectedRows);
        this.setState({ selectedRows: selectedRows });
      },
      getCheckboxProps: record => ({
        disabled: record.name === 'Disabled User', // Column configuration not to be checked
        name: record.name,
      }),
    };

    const { RangePicker } = DatePicker;

    const genExtra = value =>
      value && value.length > 0 && value[0].valorChar !== null ? (
        <Badge count={1} style={{ backgroundColor: '#52c41a' }} />
      ) : (
        <Badge count={0} showZero />
      );

    return (
      <Layout>
        <Sidebar
          dataSidebar={homeClient}
          routes={routesClient}
          current="dashboard"
        />
        <Layout>
          <Header dataUser={this.state.dataUser} />
          <Content
            style={{
              margin: '24px 16px',
              padding: 24,
              background: '#fff',
              minHeight: 280,
            }}
          >
            <Row className="nopadding-col">
              <Col md={{ span: 16 }} xs={{ span: 24 }}>
                <Breadcrumb pages={[{ title: 'Avaliações' }]} />
              </Col>
            </Row>
            <Row style={{ backgroundColor: '#f0f2f5' }}>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 6 }}
                md={{ span: 6 }}
                lg={{ span: 6 }}
                style={{ margin: 20 }}
              >
                <Row style={{ display: 'flex', flexDirection: 'column' }}>
                  <h1>Por comentários</h1>
                  <Row style={{ display: 'flex', flexDirection: 'row' }}>
                    <Switch
                      checked={this.state.elogio}
                      onChange={e => this.onChange(e, ELOGIOS)}
                      style={{ marginRight: 10 }}
                    />
                    <p>Elogios / Sugestões / Comentários</p>
                  </Row>
                  <Row style={{ display: 'flex', flexDirection: 'row' }}>
                    <Switch
                      checked={this.state.critica}
                      onChange={e => this.onChange(e, CRITICA)}
                      style={{ marginRight: 10 }}
                    />
                    <p>Críticas / Reclamações</p>
                  </Row>
                </Row>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 6 }}
                md={{ span: 6 }}
                lg={{ span: 6 }}
                style={{ margin: 20 }}
              >
                <Row style={{ display: 'flex', flexDirection: 'column' }}>
                  <h1>Por tipo</h1>
                  <Row style={{ display: 'flex', flexDirection: 'row' }}>
                    <Switch
                      checked={this.state.detrator}
                      onChange={e => this.onChange(e, DETRATOR)}
                      style={{ marginRight: 10 }}
                    />
                    <p>Detrator</p>
                  </Row>
                  <Row style={{ display: 'flex', flexDirection: 'row' }}>
                    <Switch
                      checked={this.state.neutro}
                      onChange={e => this.onChange(e, NEUTRO)}
                      style={{ marginRight: 10 }}
                    />
                    <p>Neutro</p>
                  </Row>
                  <Row style={{ display: 'flex', flexDirection: 'row' }}>
                    <Switch
                      checked={this.state.promotor}
                      onChange={e => this.onChange(e, PROMOTOR)}
                      style={{ marginRight: 10 }}
                    />
                    <p>Promotor</p>
                  </Row>
                </Row>
              </Col>
              <Col
                xs={{ span: 20 }}
                sm={{ span: 8 }}
                md={{ span: 8 }}
                lg={{ span: 8 }}
                style={{ margin: 20 }}
              >
                <h1>Período</h1>
                {this.state.dataInitial !== undefined ? (
                  // Controlado (value, nao defaultValue): assim o campo sempre
                  // reflete o periodo que os dados na tela realmente usam.
                  <RangePicker
                    value={[
                      moment(dataInitial, DATE_FORMAT),
                      moment(dataFinal, DATE_FORMAT),
                    ]}
                    format={FORMATO_EXIBICAO}
                    placeholder={['Data inicial', 'Data final']}
                    onChange={this.onChangeFeedbacks}
                    onOk={this.onOk}
                  />
                ) : null}
                <Row style={{ marginTop: 20 }}>
                  <Button type="primary" onClick={this.applyFilter}>
                    Aplicar
                  </Button>
                  <Button
                    type="danger"
                    onClick={this.clearFilter}
                    style={{ marginLeft: 20 }}
                  >
                    Limpar
                  </Button>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={{ span: 20 }} md={{ span: 20 }} lg={{ span: 14 }}>
                <Table
                  rowSelection={rowSelection}
                  hideDefaultSelections={true}
                  selections={true}
                  rowKey={item => item.id}
                  columns={columns}
                  loading={this.state.loading}
                  dataSource={this.state.dataTable && this.state.dataTable}
                  pagination={{ defaultPageSize: 10 }}
                  size="middle"
                  scroll={{ x: 500 }}
                  rowClassName={this.setRowClassName}
                  onRow={this.onClickRow}
                />
              </Col>
              <Col
                xs={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 10 }}
                style={{
                  backgroundColor: '#FFF',
                  border: '1px solid rgba(0, 0, 0, 0.10)',
                  padding: '1rem',
                  background: 'rgba(213, 237, 250, 0.3)',
                  marginTop: 10,
                }}
              >
                <Row>
                  <Col xs={{ span: 24 }} md={{ span: 16 }} lg={{ span: 16 }}>
                    <Row
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Col>
                        <h1>Racionais</h1>
                        <List
                          itemLayout="horizontal"
                          dataSource={this.state.racionaisTitles}
                          renderItem={item => (
                            <List.Item>
                              <List.Item.Meta
                                title={item.title}
                                description={`Avaliação: ${item.description}`}
                              />
                            </List.Item>
                          )}
                        />
                      </Col>
                      <Col>
                        <h1>Emocionais</h1>
                        <List
                          itemLayout="horizontal"
                          dataSource={this.state.emocionaisTitles}
                          renderItem={item => (
                            <List.Item>
                              <List.Item.Meta
                                title={item.title}
                                description={`Avaliação: ${item.description}`}
                              />
                            </List.Item>
                          )}
                        />
                      </Col>

                      <Col>
                        <h1>Outros</h1>
                        <List
                          itemLayout="horizontal"
                          dataSource={this.state.outrosTitles}
                          renderItem={item => (
                            <List.Item>
                              <List.Item.Meta
                                title={item.title}
                                description={`${item.description}`}
                              />
                            </List.Item>
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    xs={{ span: 12, offset: 10 }}
                    md={{ span: 6, offset: 0 }}
                    lg={{ span: 4, offset: 3 }}
                    style={{ marginTop: 10 }}
                  >
                    <Row
                      style={{ marginBottom: 10, textAlign: '-webkit-center' }}
                    >
                      <h1 style={{ fontSize: '0.8rem' }}>
                        Índice Blue Individual
                      </h1>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: '#0a2851',
                          borderRadius: '50%',
                          height: 80,
                          width: 80,
                          marginTop: 30,
                        }}
                      >
                        <h1 style={{ color: '#FFF', fontSize: 20 }}>
                          {this.state.record &&
                          this.state.record.indiceBlue != undefined &&
                          this.state.record.indiceBlue >= 0
                            ? this.state.record.indiceBlue.toFixed()
                            : '--'}
                        </h1>
                        {this.state.record &&
                        this.state.record.indiceBlue != undefined &&
                        this.state.record.indiceBlue >= 0 ? (
                          <p style={{ color: '#FFF', fontSize: 10 }}>0 -100</p>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div>
                        <div style={{ marginTop: 40 }}>
                          <h3 style={{ fontSize: '0.8rem' }}>
                            Nota NPS Individual{' '}
                          </h3>
                        </div>
                        <Card
                          style={{
                            width: 100,
                            display: 'flex',
                            justifyContent: 'center',
                            backgroundColor: '#f0f2f5',
                            transform: 'translateX(-1.05rem)',
                          }}
                        >
                          <h1
                            style={{
                              color: 'blue',
                              fontSize: 20,
                              textAlign: 'center',
                            }}
                          >
                            {this.state.record && this.state.record.nps !== null
                              ? this.state.record.nps
                              : 0}
                          </h1>
                          <p
                            style={{
                              color: 'blue',
                              fontSize: 10,
                              textAlign: 'center',
                            }}
                          >
                            0 -10
                          </p>
                          <div
                            style={{
                              backgroundColor: this.getTypeColor(
                                this.state.record.type
                              ),
                              width: 100,
                            }}
                          >
                            <p
                              style={{
                                color: '#FFF',
                                fontSize: 14,
                                textAlign: 'center',
                              }}
                            >
                              {this.state.record.type}
                            </p>
                          </div>
                        </Card>
                      </div>
                    </Row>
                  </Col>
                </Row>
                <Col style={{ marginTop: 46 }}>
                  <Collapse accordion style={{ marginBottom: 50 }}>
                    <Panel
                      header="ELOGIOS / SUGESTÕES / COMENTÁRIOS"
                      key="2"
                      extra={genExtra(this.state.elogios && this.state.elogios)}
                      style={{
                        color: '#000',
                        '.ant-collapse-content': {
                          backgroundColor: '#000',
                        },
                      }}
                    >
                      {this.state.elogios && this.state.elogios.length > 0 ? (
                        <p>{this.state.elogios[0].valorChar}</p>
                      ) : null}
                    </Panel>
                    <Panel
                      header="CRÍTICAS / RECLAMAÇÕES"
                      key="3"
                      extra={genExtra(
                        this.state.criticas && this.state.criticas
                      )}
                    >
                      {this.state.criticas && this.state.criticas.length > 0 ? (
                        <p>{this.state.criticas[0].valorChar}</p>
                      ) : null}
                    </Panel>
                  </Collapse>
                </Col>
              </Col>
            </Row>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

Comments.propTypes = {
  history: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getUserData, setChecketedRow }, dispatch);

const mapStateToProps = store => ({
  userData: store.userData.data,
  clientFilial: store.userData.clientFilial,
  filialId: store.userData.filialId,
  rowSelected: store.userData.rowSelected,
  companySelected: store.userData.companySelected,
  dataFilial: store.userData.dataFilial,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Comments));
